<template>
  <v-form v-model="formStatus.valid">
    <v-row>
      <v-col cols="12">
        <v-text-field
          filled
          label="Project title"
          v-model="editedData.name"
          :rules="[rules.required]"
          required
        >
          <template v-slot:append>
            <span class="hint">* required</span>
          </template>
        </v-text-field>
        <v-textarea
          filled
          label="Description"
          v-model="editedData.description"
        ></v-textarea>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { textFieldRules } from '@/common'

export default {
  props: {
    editedData: {
      type: Object,
      default: () => ({ name: '', description: '' }),
    },
    formStatus: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      rules: textFieldRules,
    }
  },
}
</script>